import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import Categories from "@/components/Categories";
import FeaturedProducts from "@/components/FeaturedProducts";
import About from "@/components/About";
import TrustedBy from "@/components/TrustedBy";
import ContactForm from "@/components/ContactForm";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-white text-[#0A1128]">
      <Header />
      <main>
        <Hero />
        <Categories />
        <FeaturedProducts />
        <About />
        <TrustedBy />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
